import {Detail} from './Detail';

export class ArticoloBase extends Detail{
  codice: string;
  descrizione: string;
}

export class Articolo extends Detail{
  organizzazioneId: number;
  id: number;
  codArt: string;
  varianteArt?: string;
  desArt: string;
  desEstesaArt?: string;
  desEstesaVariante?: string;
  tipoArt: number;
  umMag: string;
  magNumDecimaliQtaUm: number;
  umMag2?: string;
  magNumDecimaliQtaUm2?: number;
  coeffUm2MagNum?: number;
  coeffUm2MagDen?: number;
  acqUm?: string;
  acqCoeffUmNum?: number;
  acqCoeffUmDen?: number;
  venUm?: string;
  venCoeffUmNum?: number;
  venCoeffUmDen?: number;
  tecniciUm?: string;
  tecniciCoeffUmNum?: number;
  tecniciCoeffUmDen?: number;
  giacPerLotti: number;
  magUmPeso?: number;
  umPesoNettoUnit?: number;
  pesoNettoUnit?: number;
  umPesoLordoUnit?: number;
  pesoLordoUnit?: number;
  umVolumeUnit?: number;
  volumeUnit?: number;
  unitaPerCollo?: number;
  colliPerStrato?: number;
  stratiPerUnitaCarico?: number;
  colliPerUnitaCarico?: number;
  umDimensioni?: number;
  altezza?: number;
  larghezza?: number;
  profondita?: number;
  statoArt?: number;
  codMicrofamiglia?: string;
  desMicroFamiglia?: string;
  codFamiglia?: string;
  desFamiglia?: string;
  codMacroFamiglia?: string;
  desMacroFamiglia?: string;
  codMagStoccaggio?: string;
  areaMagStoccaggio?: string;
  giacenza?: number;
  giacenzaUdM2?: number;
  classeLogistica?: string;
}
